// Estado de la recepción conforme de una entrega.
//
// Son tres y no un sí/no porque "no está firmado" y "no hay nada que firmar" se arreglan de
// maneras distintas: el primero es perseguir al chofer, el segundo es un problema del ERP.
export const RECEPTION_LABELS = {
    signed: "Firmada",
    pending: "Pendiente",
    missing: "Sin documento",
};

export const RECEPTION_COLORS = {
    signed: "success",
    pending: "warning",
    missing: "error",
};

export const REGULARIZATION_LABELS = {
    "not-applicable": "—",
    pending: "Pendiente",
    done: "Regularizada",
};

export const REGULARIZATION_COLORS = {
    "not-applicable": "default",
    pending: "warning",
    done: "success",
};

// Los filtros de estado que ofrece la barra superior. "pending" es el que justifica la
// pantalla, así que es el primero después de "todas".
export const DOCUMENT_STATUS_OPTIONS = [
    { value: "", label: "Todas" },
    { value: "pending", label: "Sin firmar" },
    { value: "signed", label: "Firmadas" },
    { value: "missing", label: "Sin documento del ERP" },
];
